import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Top scroll progress indicator + scroll-linked thin bar.
 * Adds a subtle, persistent sense of motion as the user scrolls.
 */
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-[2px] bg-white z-[60] origin-left pointer-events-none"
    />
  );
};

export default ScrollProgress;
